import React, { useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { Eyebrow } from '../ui/Eyebrow';
import { faqs } from '../../data/faqs';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  const reduce = useReducedMotion();
  return <section aria-labelledby="faq-heading" className="bg-white" data-id="element-70" data-mp="122vemlij93s4">
      <div className="mx-auto max-w-3xl px-5 py-16 md:py-24" data-id="element-71" data-mp="1prxtxmpp2kjg">
        <div className="text-center" data-id="element-72" data-mp="1urarb1e6za0a">
          <Eyebrow onLight data-id="element-73" data-mp="1uq92zv860r0m">Before you get started</Eyebrow>
          <h2 id="faq-heading" className="mt-3 font-display text-5xl font-extrabold uppercase leading-[0.92] text-forest md:text-6xl" data-id="element-74" data-mp="1g2eaaeu5qmnj">
            Frequently asked <span className="text-gold-dark" data-id="element-75" data-mp="1kz4osxqbda6u">questions</span>
          </h2>
        </div>
        <ul className="mt-10 space-y-3" data-id="element-76" data-mp="28pqtqg50uecm">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          const panelId = `faq-panel-${i}`;
          const buttonId = `faq-button-${i}`;
          return <li key={faq.question} className={`rounded-xl border bg-white transition-colors duration-150 ease-out ${isOpen ? 'border-gold' : 'border-forest/10'}`} data-id="element-77" data-mp="2jre4r81ec0l9" data-mpi={i}>
                <h3 data-id="element-78" data-mp="2tnqxa2l7g8ef">
                  <button id={buttonId} type="button" aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/40 sm:px-6" data-id="element-79" data-mp="2tn8t8jsawpvy">
                    <span className="text-base font-semibold text-forest sm:text-lg" data-id="element-80" data-mp="1n0damf6lsx6p">{faq.question}</span>
                    <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-[background-color,transform] duration-200 ease-out ${isOpen ? 'rotate-45 bg-gold text-forest' : 'bg-mint text-forest'}`} data-id="element-81" data-mp="1i2k41l1e215w">
                      <PlusIcon aria-hidden="true" className="h-4 w-4" strokeWidth={3} data-id="element-82" data-mp="2gp16a9h9vv6u" />
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-83" data-mp="2qpblu0qs5ep6">
                  {isOpen && <motion.div id={panelId} role="region" aria-labelledby={buttonId} initial={reduce ? {
                opacity: 0
              } : {
                height: 0,
                opacity: 0
              }} animate={reduce ? {
                opacity: 1
              } : {
                height: 'auto',
                opacity: 1
              }} exit={reduce ? {
                opacity: 0
              } : {
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-84" data-mp="2uqdic9tbbcng">
                      <p className="px-5 pb-5 text-base leading-relaxed text-forest/75 sm:px-6" data-id="element-85" data-mp="12slsw8tfk6os">{faq.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}